webpackJsonp([11078321823668],{

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DBAb.e19f1a63.png";

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SLAMAf.62cecc53.png";

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bcj.bf8042c5.png";

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ddbd_dual.2b53d353.png";

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ddbd_frame.474796c9.png";

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ddbd_p.69f18896.png";

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ddbd_w.66963119.png";

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ldm.24338ac5.png";

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rcc.09e24b0d.png";

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rcr.a5a4e0ed.png";

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _radium = __webpack_require__(48);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _sharedStyles = __webpack_require__(730);
	
	var _sharedStyles2 = _interopRequireDefault(_sharedStyles);
	
	var _projectScreenshot = __webpack_require__(728);
	
	var _projectScreenshot2 = _interopRequireDefault(_projectScreenshot);
	
	var _sectionHeading = __webpack_require__(729);
	
	var _sectionHeading2 = _interopRequireDefault(_sectionHeading);
	
	var _rcr = __webpack_require__(862);
	
	var _rcr2 = _interopRequireDefault(_rcr);
	
	var _rcc = __webpack_require__(857);
	
	var _rcc2 = _interopRequireDefault(_rcc);
	
	var _bcj = __webpack_require__(848);
	
	var _bcj2 = _interopRequireDefault(_bcj);
	
	var _DBAb = __webpack_require__(831);
	
	var _DBAb2 = _interopRequireDefault(_DBAb);
	
	var _SLAMAf = __webpack_require__(842);
	
	var _SLAMAf2 = _interopRequireDefault(_SLAMAf);
	
	var _ddbd_frame = __webpack_require__(853);
	
	var _ddbd_frame2 = _interopRequireDefault(_ddbd_frame);
	
	var _ddbd_w = __webpack_require__(855);
	
	var _ddbd_w2 = _interopRequireDefault(_ddbd_w);
	
	var _ddbd_dual = __webpack_require__(852);
	
	var _ddbd_dual2 = _interopRequireDefault(_ddbd_dual);
	
	var _ddbd_p = __webpack_require__(854);
	
	var _ddbd_p2 = _interopRequireDefault(_ddbd_p);
	
	var _ldm = __webpack_require__(856);
	
	var _ldm2 = _interopRequireDefault(_ldm);
	
	var _dottedCircle = __webpack_require__(726);
	
	var _dottedCircle2 = _interopRequireDefault(_dottedCircle);
	
	var _circle = __webpack_require__(725);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _triangle = __webpack_require__(727);
	
	var _triangle2 = _interopRequireDefault(_triangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var generateLink = function generateLink(link, currentPath) {
	  var isLinkEN = currentPath.search('/en/');
	  var isLinkIT = currentPath.search('/it/');
	  if (isLinkEN != -1 || isLinkEN == -1 && isLinkIT == -1) return '/en/' + link;else return '/it/' + link;
	};
	
	var Appshelf = function (_React$Component) {
	  _inherits(Appshelf, _React$Component);
	
	  function Appshelf() {
	    _classCallCheck(this, Appshelf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Appshelf.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'section',
	      { id: 'work-section', className: 'diagonal clockwise', style: styles.section },
	      _react2.default.createElement(
	        'div',
	        { style: styles.projectsContainer },
	        _react2.default.createElement(
	          'div',
	          { id: 'project1', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("rcr", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _rcr2.default, description: 'RC Section - Rect' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project6', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("rcc", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _rcc2.default, description: 'RC Section - Circ' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project2', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("bcj", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _bcj2.default, description: 'Beam - Column Joint' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project2', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("DBAb", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _DBAb2.default, description: 'DBA bridge' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project2', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("SLaMAf", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _SLAMAf2.default, description: 'SLaMA Solver Frame' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project3', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("dbd_f", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _ddbd_frame2.default, description: 'DBD - Frame' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project4', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("dbd_w", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _ddbd_w2.default, description: 'DBD - Wall' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project5', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("dbd_d", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _ddbd_dual2.default, description: 'DBD - Dual system' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'project6', style: styles.screenshot },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: generateLink("dbd_p", this.props.pathname) },
	            _react2.default.createElement(_projectScreenshot2.default, { screenshotURL: _ddbd_p2.default, description: 'DBD - Pier' })
	          )
	        )
	      )
	    );
	  };
	
	  return Appshelf;
	}(_react2.default.Component);
	
	var styles = {};
	
	styles.section = {
	  background: "white",
	  position: "relative"
	};
	
	styles.container = {
	  marginTop: "3%",
	  padding: 0,
	  marginBottom: "7%"
	};
	
	styles.featuredImage = {
	  width: "20%",
	  position: "relative",
	  zIndex: 1
	};
	
	styles.shadowImage = {
	  position: "relative",
	  left: "-100px",
	  opacity: 0
	};
	
	styles.imageBefore = {
	  position: "absolute",
	  width: "102%",
	  height: "92%",
	  top: "-6%",
	  left: 0,
	  background: "#a8e4bc",
	  zIndex: -1
	};
	
	styles.rightHalf = {
	  padding: "3% 6%",
	  position: "relative",
	  top: "-100px",
	  opacity: 0
	};
	
	styles.projectsLink = {
	  textAlign: "center",
	  marginTop: "3%",
	  fontSize: "3vh"
	};
	
	styles.p = {
	  fontFamily: "RobotoMono-Regular",
	  fontSize: "30px",
	  color: "black",
	  lineHeight: "1.7"
	};
	
	styles.projectsContainer = {
	  width: "100%",
	  position: "relative",
	  paddingBottom: "8%"
	};
	
	styles.projectsFlex = {
	  display: "flex",
	  flexWrap: "wrap",
	  justifyContent: "center"
	};
	
	styles.screenshot = {
	  display: "inline-block",
	  width: "100%",
	  "@media screen and (min-width: 768px)": {
	    width: "calc(33.3333%)"
	  }
	};
	
	exports.default = (0, _radium2.default)(Appshelf);
	module.exports = exports['default'];

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _radium = __webpack_require__(48);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _color = __webpack_require__(733);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _appshelf = __webpack_require__(773);
	
	var _appshelf2 = _interopRequireDefault(_appshelf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Apps = function (_React$Component) {
	    _inherits(Apps, _React$Component);
	
	    function Apps() {
	        _classCallCheck(this, Apps);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Apps.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { id: 'pin-container' },
	            _react2.default.createElement(
	                _radium.StyleRoot,
	                null,
	                _react2.default.createElement(_appshelf2.default, { data: this.props.data, pathname: this.props.location.pathname })
	            )
	        );
	    };
	
	    return Apps;
	}(_react2.default.Component);
	
	exports.default = Apps;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-apps-en-jsx-ac23924e8187208ce71f.js